import { StaticTextRendering } from '../../../../../../../types/types';
import JsonView from '../../../../../../JsonView/JsonView';
import { parseStringValue } from '../../../../utils/parseStringValue';
import { toJsonEditorValue } from '../../../../utils/toJsonEditorValue';
import MarkdownView from '../../../MarkdownView/MarkdownView';

interface StaticTextBodyProps {
  value: string | null;
  rendering: StaticTextRendering;
  rows: number;
}

const StaticTextBody = ({ value, rendering, rows }: StaticTextBodyProps) => {
  const height = `${rows * 1.5}em`;

  if (rendering === 'json') {
    return (
      <JsonView
        value={value}
        minHeight={height}
        maxHeight={height}
        className="static-text"
      />
    );
  }

  if (rendering === 'markdown') {
    return (
      <MarkdownView
        value={value}
        maxHeight={height}
        minHeight={height}
        className="static-text"
      />
    );
  }

  const snaitizedStaticValue =
    typeof value === 'object' && value !== null
      ? toJsonEditorValue(value)
      : parseStringValue(value);

  return (
    <div className="static-text" style={{ height }}>
      {snaitizedStaticValue}
    </div>
  );
};

export default StaticTextBody;
